module.exports = __webpack_public_path__ + "static/ANGACOM_events-og-image-c226faad9dfc15aaf40307909bc14927.jpg";